import styled from 'styled-components'

import * as Styles from '../Common/styles'

export const Wrapper = styled(Styles.Wrapper)`
  padding: 0 31px;
`
